import React from 'react';
import { Icons, NamedLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import css from './LandingPage.module.css';

function SectionPropertyInfo() {
  return (
    <div className={css.propertySection}>
      <div className={css.contentWidth}>
        <div className={css.sectionContent}>
          <div className={css.sectionHead}>
            <p className={css.eyebrow}>
              <FormattedMessage id="LandingPage.propertyEyebrow" />
            </p>
            <h2 className={css.propertyHeading}>
              <FormattedMessage id="LandingPage.propertyHeading" />
            </h2>
            <p>
              <FormattedMessage id="LandingPage.propertyDescription" />
            </p>
          </div>
          <div className={css.hospitalitySec}>
            <div className={css.infoBlock}>
              <div className={css.infoIcon}>
                <Icons name="sleep" />
              </div>
              <h3>
                <FormattedMessage id="LandingPage.discoverHeading" />
              </h3>
              <ul>
                <li>
                  <span>
                    <FormattedMessage id="LandingPage.discoverDetail1" />
                  </span>
                </li>
                <li>
                  <span>
                    <FormattedMessage id="LandingPage.discoverDetail2" />
                  </span>
                </li>
              </ul>
              <NamedLink name="SearchPage">
                <FormattedMessage id="LandingPage.browseLink" />
              </NamedLink>
            </div>
            <div className={css.infoBlock}>
              <div className={css.infoIcon}>
                <Icons name="heartHand" />
              </div>
              <h3>
                <FormattedMessage id="LandingPage.planHeading" />
              </h3>
              <ul>
                <li>
                  <span>
                    <FormattedMessage id="LandingPage.planDetail1" />
                  </span>
                </li>
                <li>
                  <span>
                    <FormattedMessage id="LandingPage.planDetail2" />
                  </span>
                </li>
              </ul>
            </div>
            <div className={css.infoBlock}>
              <div className={css.infoIcon}>
                <Icons name="sleep" />
              </div>
              <h3>
                <FormattedMessage id="LandingPage.hostHeading" />
              </h3>
              <ul>
                <li>
                  <span>
                    <FormattedMessage id="LandingPage.hostDetail1" />
                  </span>
                </li>
                <li>
                  <span>
                    <FormattedMessage id="LandingPage.hostDetail2" />
                  </span>
                </li>
              </ul>
              <NamedLink name="NewListingPage">
                <FormattedMessage id="Host.listProperty" />
              </NamedLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionPropertyInfo;
